export default {
  pearls: `
    .assessment-result-container .resource-result .action-menu-dropdown {
      width: 100%;
      background: none !important;
    }
    .assessment-result-container .resource-result .distance-text {
      display: none;
    }
  `
};
